import { Toaster } from "react-hot-toast";
import "./App.css";
import Routers from "./routes";
import "./styles/_global.scss";

function App() {
  return (
    <div className="body-full-section-layer">
      <Toaster />
      <Routers />
    </div>
  );
}

export default App;
